import React from 'react';
import PropTypes from 'prop-types';
import { deepExtract } from 'helpers/deep';
import { extractRafRewards } from 'components/Friendbuy/FriendbuyWidget';
import { ProductLinks } from '../NavItems/ProductLinks';
import { RafNavItem } from '../NavItems/RafNavItem';
import { UpcomingNavItem } from '../NavItems/UpcomingNavItem';

export const ActiveUserNav = ({ isLivePage, isGoPage, user }) => {
  const { rafSenderReward } = extractRafRewards(user);

  return (
    <>
      {!isLivePage && !isGoPage && <ProductLinks />}
      <UpcomingNavItem count={deepExtract('reservation_info.upcoming_reservation_count', user, 0)} />
      {rafSenderReward && <RafNavItem reward={rafSenderReward} user={user} />}
    </>
  );
};

ActiveUserNav.propTypes = {
  isLivePage: PropTypes.bool,
  isGoPage: PropTypes.bool,
  user: PropTypes.object.isRequired,
};
